import { __decorate, __param } from 'tslib';
import { DOCUMENT, CommonModule } from '@angular/common';
import { SecurityContext, Inject, Sanitizer, Optional, ElementRef, Input, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WINDOW, USER_AGENT } from '@ng-web-apis/common';
import { isIE, getDocumentOrShadowRoot, tuiCustomEvent, tuiAssert, TuiStaticRequestService, tuiRequiredSetter, tuiPure, TuiLetModule } from '@taiga-ui/cdk';
import { TUI_ICON_ERROR } from '@taiga-ui/core/constants';
import { TuiSvgService } from '@taiga-ui/core/services';
import { TUI_ICONS_PATH, TUI_SANITIZER, TUI_SVG_SRC_PROCESSOR, TUI_SVG_CONTENT_PROCESSOR } from '@taiga-ui/core/tokens';
import { isPresumedHTMLString } from '@taiga-ui/core/utils/miscellaneous';
import { ReplaySubject, of } from 'rxjs';
import { switchMap, startWith, catchError, map } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/cdk';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@taiga-ui/core/services';
import * as ɵngcc4 from '@angular/platform-browser';

function TuiSvgComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 3);
} if (rf & 2) {
    const innerHTML_r1 = ɵngcc0.ɵɵnextContext().tuiLet;
    ɵngcc0.ɵɵproperty("innerHTML", innerHTML_r1, ɵngcc0.ɵɵsanitizeHtml);
} }
function TuiSvgComponent_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 4);
    ɵngcc0.ɵɵlistener("error", function TuiSvgComponent_ng_container_0_ng_template_2_Template__svg_svg_error_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.onError(); });
    ɵngcc0.ɵɵelement(1, "use");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("href", ctx_r4.use, null, "xlink");
} }
function TuiSvgComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TuiSvgComponent_ng_container_0_div_1_Template, 1, 1, "div", 1);
    ɵngcc0.ɵɵtemplate(2, TuiSvgComponent_ng_container_0_ng_template_2_Template, 2, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r3 = ɵngcc0.ɵɵreference(3);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isInnerHTML)("ngIfElse", _r3);
} }
const UNDEFINED_NAMED_ICON = 'Attempted to use undefined named icon';
const MISSING_EXTERNAL_ICON = 'External icon is missing on the given URL';
const FAILED_EXTERNAL_ICON = 'Failed to load external SVG';
// TODO: Consider moving to CDK along with SvgService and SvgDefsHostComponent
// @dynamic
let TuiSvgComponent = class TuiSvgComponent {
    constructor(documentRef, windowRef, iconsPath, tuiSanitizer, svgService, staticRequestService, sanitizer, elementRef, userAgent, srcProcessor, contentProcessor) {
        this.documentRef = documentRef;
        this.windowRef = windowRef;
        this.iconsPath = iconsPath;
        this.tuiSanitizer = tuiSanitizer;
        this.svgService = svgService;
        this.staticRequestService = staticRequestService;
        this.sanitizer = sanitizer;
        this.elementRef = elementRef;
        this.userAgent = userAgent;
        this.srcProcessor = srcProcessor;
        this.contentProcessor = contentProcessor;
        this.src$ = new ReplaySubject(1);
        this.isIE = isIE(this.userAgent);
        this.icon = '';
        this.innerHTML$ = this.src$.pipe(switchMap(() => this.isExternal
            ? this.getExternalIcon(this.icon)
            : of(this.getSafeHtml(this.icon))), startWith(''));
    }
    set src(src) {
        this.icon = this.srcProcessor(src);
        this.src$.next();
    }
    get src() {
        return this.icon;
    }
    get use() {
        return this.icon.includes('.svg#')
            ? this.icon
            : this.resolveName(this.icon, this.iconsPath);
    }
    get isInnerHTML() {
        return this.isSrc || this.isExternal || (this.isName && this.isShadowDOM);
    }
    get isShadowDOM() {
        return (getDocumentOrShadowRoot(this.elementRef.nativeElement) !== this.documentRef);
    }
    get isUse() {
        return this.use.includes('.svg#');
    }
    get isExternal() {
        return this.isUrl || (this.isIE && this.isUse) || this.isCrossDomain;
    }
    get isUrl() {
        return this.icon.endsWith('.svg');
    }
    get isSrc() {
        return isPresumedHTMLString(this.icon);
    }
    get isName() {
        return !this.isUrl && !this.isUse && !this.isSrc;
    }
    get isCrossDomain() {
        const { use, isUse, windowRef } = this;
        return (isUse &&
            use.startsWith('http') &&
            !!windowRef.origin &&
            !use.startsWith(windowRef.origin));
    }
    onError(message = MISSING_EXTERNAL_ICON) {
        const { icon } = this;
        const event = tuiCustomEvent(TUI_ICON_ERROR, {
            bubbles: true,
            detail: {
                message,
                icon,
            },
        }, this.documentRef);
        tuiAssert.assert(false, message, icon);
        this.elementRef.nativeElement.dispatchEvent(event);
    }
    resolveName(name, iconsPath) {
        return iconsPath(name);
    }
    getSafeHtml(src) {
        return this.isSrc ? this.sanitize(src) : this.process(src);
    }
    process(src) {
        const icon = this.svgService.getOriginal(src);
        if (this.isName && !icon && !!src) {
            this.onError(UNDEFINED_NAMED_ICON);
        }
        // Empty line for innerHTML when icon is shown through USE tag
        return !this.isShadowDOM || !this.isName ? '' : this.sanitize(icon || '');
    }
    sanitize(src) {
        src = this.contentProcessor(src);
        return this.tuiSanitizer
            ? this.sanitizer.bypassSecurityTrustHtml(this.tuiSanitizer.sanitize(SecurityContext.HTML, src) || '')
            : src;
    }
    getExternalIcon(src) {
        const url = src.includes('.svg') ? src : this.use;
        return this.staticRequestService.request(url).pipe(catchError(() => {
            this.onError(FAILED_EXTERNAL_ICON);
            return of('');
        }), map(response => this.sanitize(response.replace('<svg', '<svg focusable="false"'))));
    }
};
TuiSvgComponent.ɵfac = function TuiSvgComponent_Factory(t) { return new (t || TuiSvgComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(WINDOW), ɵngcc0.ɵɵdirectiveInject(TUI_ICONS_PATH), ɵngcc0.ɵɵdirectiveInject(TUI_SANITIZER, 8), ɵngcc0.ɵɵdirectiveInject(TuiSvgService), ɵngcc0.ɵɵdirectiveInject(TuiStaticRequestService), ɵngcc0.ɵɵdirectiveInject(DomSanitizer), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(USER_AGENT), ɵngcc0.ɵɵdirectiveInject(TUI_SVG_SRC_PROCESSOR), ɵngcc0.ɵɵdirectiveInject(TUI_SVG_CONTENT_PROCESSOR)); };
TuiSvgComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiSvgComponent, selectors: [["tui-svg"]], inputs: { src: "src" }, decls: 2, vars: 3, consts: [[4, "tuiLet"], ["class", "src", 3, "innerHTML", 4, "ngIf", "ngIfElse"], ["useTemplate", ""], [1, "src", 3, "innerHTML"], ["version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "focusable", "false", "width", "100%", "height", "100%", 3, "error"]], template: function TuiSvgComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiSvgComponent_ng_container_0_Template, 4, 2, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("tuiLet", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.innerHTML$));
    } }, directives: [ɵngcc1.TuiLetDirective, ɵngcc2.NgIf], pipes: [ɵngcc2.AsyncPipe], styles: ["[_nghost-%COMP%]{display:inline-block;vertical-align:middle;flex-shrink:0;line-height:0;height:1.5rem;width:1.5rem;fill:currentColor;font-size:1rem}.src[_ngcontent-%COMP%]{display:flex;height:100%;align-items:center;justify-content:center}"], changeDetection: 0 });
TuiSvgComponent.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Window, decorators: [{ type: Inject, args: [WINDOW,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_ICONS_PATH,] }] },
    { type: Sanitizer, decorators: [{ type: Optional }, { type: Inject, args: [TUI_SANITIZER,] }] },
    { type: TuiSvgService, decorators: [{ type: Inject, args: [TuiSvgService,] }] },
    { type: TuiStaticRequestService, decorators: [{ type: Inject, args: [TuiStaticRequestService,] }] },
    { type: DomSanitizer, decorators: [{ type: Inject, args: [DomSanitizer,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: String, decorators: [{ type: Inject, args: [USER_AGENT,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_SVG_SRC_PROCESSOR,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_SVG_CONTENT_PROCESSOR,] }] }
];
__decorate([
    Input(),
    tuiRequiredSetter()
], TuiSvgComponent.prototype, "src", null);
__decorate([
    tuiPure
], TuiSvgComponent.prototype, "resolveName", null);
TuiSvgComponent = __decorate([ __param(0, Inject(DOCUMENT)),
    __param(1, Inject(WINDOW)),
    __param(2, Inject(TUI_ICONS_PATH)),
    __param(3, Optional()),
    __param(3, Inject(TUI_SANITIZER)),
    __param(4, Inject(TuiSvgService)),
    __param(5, Inject(TuiStaticRequestService)),
    __param(6, Inject(DomSanitizer)),
    __param(7, Inject(ElementRef)),
    __param(8, Inject(USER_AGENT)),
    __param(9, Inject(TUI_SVG_SRC_PROCESSOR)),
    __param(10, Inject(TUI_SVG_CONTENT_PROCESSOR))
], TuiSvgComponent);

let TuiSvgModule = class TuiSvgModule {
};
TuiSvgModule.ɵfac = function TuiSvgModule_Factory(t) { return new (t || TuiSvgModule)(); };
TuiSvgModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiSvgModule });
TuiSvgModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TuiLetModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiSvgComponent, [{
        type: Component,
        args: [{
                selector: 'tui-svg',
                template: "<ng-container *tuiLet=\"innerHTML$ | async as innerHTML\">\n    <div\n        *ngIf=\"isInnerHTML; else useTemplate\"\n        class=\"src\"\n        [innerHTML]=\"innerHTML\"\n    ></div>\n    <ng-template #useTemplate>\n        <svg\n            version=\"1.1\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n            xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n            focusable=\"false\"\n            width=\"100%\"\n            height=\"100%\"\n            (error)=\"onError()\"\n        >\n            <use [attr.xlink:href]=\"use\"></use>\n        </svg>\n    </ng-template>\n</ng-container>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:inline-block;vertical-align:middle;flex-shrink:0;line-height:0;height:1.5rem;width:1.5rem;fill:currentColor;font-size:1rem}.src{display:flex;height:100%;align-items:center;justify-content:center}"]
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: Window, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_ICONS_PATH]
            }] }, { type: ɵngcc0.Sanitizer, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [TUI_SANITIZER]
            }] }, { type: ɵngcc3.TuiSvgService, decorators: [{
                type: Inject,
                args: [TuiSvgService]
            }] }, { type: ɵngcc1.TuiStaticRequestService, decorators: [{
                type: Inject,
                args: [TuiStaticRequestService]
            }] }, { type: ɵngcc4.DomSanitizer, decorators: [{
                type: Inject,
                args: [DomSanitizer]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [USER_AGENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_SVG_SRC_PROCESSOR]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_SVG_CONTENT_PROCESSOR]
            }] }]; }, { src: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiSvgModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TuiLetModule],
                declarations: [TuiSvgComponent],
                exports: [TuiSvgComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiSvgModule, { declarations: function () { return [TuiSvgComponent]; }, imports: function () { return [CommonModule, TuiLetModule]; }, exports: function () { return [TuiSvgComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiSvgComponent, TuiSvgModule };

